import { gql } from '@apollo/client';

export const SEND_CABLE_REEL_MAIL = gql`
    mutation SendCableReelMail($cableReelMailInput: CableReelMailInputType!) {
        sendCableReelMail(cableReelMailInput: $cableReelMailInput)
    }
`;
